import type { VideoProvider, ChatProvider } from './types';
import { TwilioVideoProvider } from './twilio/TwilioVideoProvider';
import { TwilioChatProvider } from './twilio/TwilioChatProvider';
import { DemoChatProvider } from './demo/DemoChatProvider';
import { env } from '../config/env';

export type { VideoProvider, ChatProvider, VideoRoomState, ChatState, ChatMessage } from './types';

// Current provider (can be changed for migration)
const VIDEO_PROVIDER = 'twilio' as const;
const CHAT_PROVIDER = 'twilio' as const;

export function createVideoProvider(): VideoProvider {
  switch (VIDEO_PROVIDER) {
    case 'twilio':
      return new TwilioVideoProvider();
    // Future: case 'daily': return new DailyVideoProvider();
    // Future: case 'livekit': return new LiveKitProvider();
    default:
      throw new Error(`Unknown video provider: ${VIDEO_PROVIDER}`);
  }
}

export function createChatProvider(): ChatProvider {
  // Demo mode routing (SPEC-030): return DemoChatProvider to avoid Twilio SDK
  if (env.demoMode) {
    return new DemoChatProvider();
  }

  switch (CHAT_PROVIDER) {
    case 'twilio':
      return new TwilioChatProvider();
    // Future: case 'daily': return new DailyChatProvider();
    default:
      throw new Error(`Unknown chat provider: ${CHAT_PROVIDER}`);
  }
}
